import axios from "axios";
import { getConfig } from "../config/config";

export async function createResearch(token: string, formdataResearch: any): Promise<any> {
  try {
    const response = await axios.post(
      getConfig().API_URL + "/criarNovaPesquisa",
      formdataResearch,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return { success: true, message: "", result: response.data };
  } catch (error: any) {
    const backendMsg =
      error?.response?.data?.error ||
      error?.response?.data?.msg ||
      error?.response?.data?.message;

    return {
      success: false,
      message: backendMsg || error?.message || "Erro desconhecido. Tente novamente mais tarde.",
      status: error?.response?.status,
      result: error?.response?.data,
    };
  }
}
